<template>
  <div>
    <transition name="dashboard">
      <div class="main-div">
        <h1>{{ title }}</h1>
        <v-row class="mt-10">
          <v-col md="6" sm="12" style="border: 5px solid;">
            <v-autocomplete
              v-model="selectedProduct"
              :items="resource.product"
              item-text="name"
              return-object
              label="Produk"
              :loading="loadingProduct"
            ></v-autocomplete>
            <v-row style=" max-width: 50%;">
              <v-col cols="6">
                <h4>Jenis</h4>
              </v-col>
              <v-col cols="6"> : {{ selectedProduct.type }} </v-col>
            </v-row>
            <v-row style=" max-width: 50%;">
              <v-col cols="6">
                <h4>Tarif Iuran</h4>
              </v-col>
              <v-col cols="6">
                : <span v-show="selectedProduct.due_year"> {{ selectedProduct.due_year }} %</span>
              </v-col>
            </v-row>
            <v-row style=" max-width: 50%;">
              <v-col cols="6">
                <h4>Jangka Waktu</h4>
              </v-col>
              <v-col cols="6">
                :
                <span v-show="selectedProduct.due_max"
                  >{{ selectedProduct.due_min }} Bulan - {{ selectedProduct.due_max }} Bulan</span
                >
              </v-col>
            </v-row>
            <v-row style=" max-width: 50%;">
              <v-col cols="6">
                <h4>Batas Plafond</h4>
              </v-col>
              <v-col cols="6">
                :
                <span v-show="selectedProduct.plafond_max"
                  >{{ getCurrency(selectedProduct.plafond_max) }}
                </span>
              </v-col>
            </v-row>
          </v-col>

          <v-col md="6" sm="12" style="border: 5px solid;">
            <v-row class="ml-2">
              <h3>Isi Data dibawah ini</h3>
              <v-icon class="blink ml-5" v-bind="attrs" v-on="on">mdi-information</v-icon>
            </v-row>
            <v-row style="max-width: 50%;">
              <v-col cols="6" class="d-flex align-center">
                <h4>Plafond</h4>
              </v-col>
              <v-col cols="6">
                <v-currency-field v-model="input.plafond" @keyup="calculateSubscription"></v-currency-field>
              </v-col>
            </v-row>
            <v-row style="max-width: 50%;">
              <v-col cols="6" class="d-flex align-center">
                <h4>Jangka Waktu</h4>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  @keypress="onlyNumber"
                  id="periode"
                  v-model="input.periode"
                  suffix="Bulan"
                  dense
                  class="detail-input__input-text"
                  required
                  :loading="loading"
                  @keyup="calculateSubscription()"
                />
              </v-col>
            </v-row>
            <v-row style="max-width: 50%;" v-if="!isFlatRateProduct">
              <v-col cols="6" class="d-flex align-center">
                <h4>Usia</h4>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  @keypress="onlyNumber"
                  id="usia"
                  v-model="input.usia"
                  suffix="Tahun"
                  dense
                  class="detail-input__input-text"
                  required
                  :loading="tariffSimulation.loading"
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" class="d-flex justify-center" v-if="tariffRows.length > 1">
            <div class="tariff-table">
              <div class="tariff-table__row tariff-table__row--head">
                <span>Tarif Iuran</span>
                <span>Jumlah</span>
              </div>
              <div class="tariff-table__row" v-for="row in tariffRows" :key="`tariff-${row.year}`">
                <span>{{ row.rowLabel }}</span>
                <span>{{ getCurrency(row.nominal) }}</span>
              </div>
            </div>
          </v-col>
          <v-col cols="12" class="d-flex justify-center align-center class my-15 ">
            <v-row style="max-width: 50%;">
              <v-col cols="6" class="d-flex align-center">
                <h1 :style="{ fontSize: $vuetify.breakpoint.mdAndUp ? '5em' : '1.5em' }">Iuran</h1>
              </v-col>
              <v-col cols="6">
                <h1 :style="{ fontSize: $vuetify.breakpoint.mdAndUp ? '5em' : '1.5em' }">
                  {{ getCurrency(input.tariff.nominal) }}
                </h1>
              </v-col>
            </v-row>
          </v-col>
          <v-col>
            <div>
              <v-alert
                class="d-flex justify-center"
                dense
                transition="scale-transition"
                :value="alert"
                :type="alertType"
              >
                {{ this.alertTitle }}
                <br v-if="this.alertTitle != ''" />
                <div class="d-flex justify-center">{{ this.alertMessage }}</div>
              </v-alert>
            </div>
          </v-col>
        </v-row>
      </div>
    </transition>
  </div>
</template>
<script>
import Swal from 'sweetalert2'
import Constant from '@/const'

import ConstantMixin from '@/constantMixin'
import { get } from 'lodash'

const _ = require('lodash')
const axios = require('axios')
const moment = require('moment')

export default {
  mixins: [ConstantMixin],
  data: () => ({
    title: 'Simulasi Iuran Peserta',
    loading: false,
    input: {
      id_product: '',
      plafond: '',
      disbursement: '',
      periode: '',
      usia: '',
      due_date: '',
      tariff: {
        percent: 0,
        nominal: 0
      }
    },
    // Hasil simulasi iuran dari Backend untuk produk non-flat, bentuknya sama dengan
    // yang dipakai halaman pendaftaran peserta.
    tariffSimulation: {
      loading: false,
      error: '',
      data: null
    },
    alert: false,
    alertType: 'success',
    alertMessage: 'ok',
    alertTitle: '',
    selectedProduct: {
      name: '',
      type: ''
    },
    resource: {
      product: []
    }
  }),
  computed: {
    // Produk non-flat memakai tabel tarif per usia (age_tariff), bukan due_year yang
    // sama untuk semua peserta. Sama dengan penentuan di halaman pendaftaran peserta.
    isFlatRateProduct() {
      const ageTariff = _.get(this.selectedProduct, 'age_tariff', [])
      return _.get(this.selectedProduct, 'isFlatRate', ageTariff.length === 0)
    },
    // Kunci permintaan simulasi. Kosong berarti belum bisa diminta — produk bertarif
    // tunggal (dihitung di layar) atau ada isian yang belum lengkap.
    tariffSimulationKey() {
      if (this.isFlatRateProduct) return ''

      const idProduct = _.get(this.selectedProduct, '_id', '')
      const plafond = Number(this.input.plafond) || 0
      const periode = Number(this.input.periode) || 0
      const usia = Number(this.input.usia) || 0

      if (!idProduct || !plafond || !periode || !usia) return ''
      return [idProduct, plafond, periode, usia].join('|')
    },
    // Baris iuran per tahun kontrak, langsung dari Backend. Produk bertarif tunggal
    // tidak punya rincian tahunan, jadi daftarnya kosong dan layar hanya menampilkan
    // nominal besarnya seperti sebelumnya.
    tariffRows() {
      return _.get(this.tariffSimulation.data, 'tariff_yearly', []).map(row => {
        const note = [`${row.age} th`]
        if (row.months !== 12) note.push(`${row.months} bln`)

        return { ...row, rowLabel: `Tahun ${row.year} (${note.join(', ')})` }
      })
    },
    disbursementFormattedMomentjs() {
      return this.input.disbursement
        ? moment(this.input.disbursement)
            .locale('id')
            .format('D MMMM YYYY')
        : ''
    },
    dueFormattedMomentjs() {
      return this.input.due_date
        ? moment(this.input.due_date)
            .locale('id')
            .format('D MMMM YYYY')
        : ''
    }
  },
  async mounted() {
    this.getProduct()
    this.alertMsg()
  },
  watch: {
    selectedProduct: {
      handler(newVal) {
        this.alertMsg()
      },
      deep: true
    },
    input: {
      handler(newVal) {
        this.alertMsg()
      },
      deep: true
    },
    // Satu pintu untuk semua pemicu simulasi: produk, plafond, jangka waktu, usia.
    tariffSimulationKey: function(val) {
      this.tariffSimulation.data = null
      this.tariffSimulation.error = ''
      this.tariffSimulation.loading = !!val
      this.input.tariff = { percent: 0, nominal: 0 }

      // Pindah ke produk bertarif tunggal mengembalikan perhitungan ke layar, jadi
      // nominalnya diisi ulang di sini supaya tidak terlanjur kosong sampai isian
      // berikutnya diketik.
      if (val) this.requestTariffSimulation(this)
      else this.calculateSubscription()
    }
  },
  methods: {
    setAlert(alert, type, msg, title) {
      this.alertType = type
      this.alert = alert
      this.alertMessage = msg
      this.alertTitle = title || ''
    },
    alertMsg() {
      this.setAlert(false, 'success', 'Simulasi Iuran Sesuai')
      if (!this?.selectedProduct?.name) return this.setAlert(true, 'info', 'Pilih Produk')
      else {
        if (!this.input.periode) return this.setAlert(true, 'info', 'Isi Jangka Waktu')
        else {
          if (this.input.periode < this.selectedProduct.due_min)
            return this.setAlert(true, 'error', `Jangka Waktu Minimal ${this.selectedProduct.due_min} Bulan`)
          if (this.input.periode > this.selectedProduct.due_max)
            return this.setAlert(true, 'error', `Jangka Waktu Maksimal ${this.selectedProduct.due_max} Bulan`)
        }
      }

      if (!this.input.plafond) return this.setAlert(true, 'info', 'Isi Plafond')
      else {
        if (this.input.plafond < this.selectedProduct.plafond_min)
          return this.setAlert(
            true,
            'error',
            `Plafond Minimal ${this.getCurrency(this.selectedProduct.plafond_min)}`
          )
        if (this.input.plafond > this.selectedProduct.plafond_max)
          return this.setAlert(
            true,
            'error',
            `Plafond Maksimal ${this.getCurrency(this.selectedProduct.plafond_max)}`
          )
      }

      if (!this.isFlatRateProduct) {
        if (!this.input.usia) return this.setAlert(true, 'info', 'Isi Usia')
        // Penolakan simulasi ditampilkan apa adanya: Backend yang tahu alasannya,
        // misalnya usia di luar tabel tarif produk.
        if (this.tariffSimulation.error) return this.setAlert(true, 'error', this.tariffSimulation.error)
      }
    },
    // Jeda supaya mengetik plafond, jangka waktu, atau usia tidak memanggil Backend
    // tiap karakter.
    requestTariffSimulation: _.debounce(v => {
      v.fetchTariffSimulation()
    }, 650),
    // Usia diterjemahkan jadi tanggal lahir dengan akad dianggap hari ini, karena
    // Backend menentukan tarif dari usia peserta pada tanggal akad — halaman ini tidak
    // meminta tanggal akad, jadi yang disimulasikan adalah akad hari ini.
    fetchTariffSimulation() {
      const key = this.tariffSimulationKey
      if (!key) return

      const idProduct = _.get(this.selectedProduct, '_id', '')
      const today = moment()

      this.runApiCalls(() => {
        axios
          .get(Constant.apiUrl.concat(`/product/${idProduct}/tariff-simulation`), {
            params: {
              plafond: Number(this.input.plafond),
              periode: Number(this.input.periode),
              birth_date: today
                .clone()
                .subtract(Number(this.input.usia), 'year')
                .format('YYYY-MM-DD'),
              disbursement: today.format('YYYY-MM-DD')
            }
          })
          .then(response => {
            // Jawaban yang sudah kedaluwarsa dibuang: isian layar berubah lagi sebelum
            // permintaan ini selesai.
            if (this.tariffSimulationKey !== key) return

            this.tariffSimulation.data = _.get(response, 'data.data', null)
            this.tariffSimulation.error = ''
            this.tariffSimulation.loading = false
            this.input.tariff = {
              percent: _.get(this.tariffSimulation.data, 'tariff.percent', 0),
              nominal: _.get(this.tariffSimulation.data, 'tariff.nominal', 0)
            }
            this.alertMsg()
          })
          .catch(error => {
            if (this.tariffSimulationKey !== key) return

            this.tariffSimulation.data = null
            this.tariffSimulation.error = _.get(
              error,
              'response.data.pesan',
              'Tidak dapat menghitung iuran, silahkan coba lagi'
            )
            this.tariffSimulation.loading = false
            this.input.tariff = { percent: 0, nominal: 0 }
            this.alertMsg()
          })
      })
    },
    calculateSubscription() {
      // Produk non-flat iurannya datang dari Backend, bukan dihitung di sini.
      if (this.isFlatRateProduct && this.input.periode && this.input.plafond) {
        this.input.tariff.percent = this.selectedProduct.due_year
        this.input.tariff.nominal = Math.round(
          this.input.plafond * (this.input.periode / 100) * this.selectedProduct.due_year
        )
      }
      if (this.input.disbursement && this.input.periode) {
        this.input.due_date = moment(this.input.disbursement)
          .add(this.input.periode, 'month')
          .format()
      }
    },
    getProduct() {
      this.loadingProduct = true
      axios.get(Constant.apiUrl.concat('/product/active?sort=code')).then(response => {
        if (response.status === 200) {
          const resData = response.data.data

          this.resource.product = resData.map(r => {
            return r
          })
          this.loadingProduct = false
        } else {
          this.resource.product = []
          this.loadingProduct = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.dashboard-enter {
  opacity: 0;
  transform: translateX(-100px);
}
.dashboard-leave-to {
  opacity: 0;
  transform: translateX(100px);
}
.dashboard-enter-active {
  transition: all 0.3s ease-in;
}

.autocomplete {
  max-width: 14%;
  margin-right: 2%;
}
.main-div {
  margin: 10px auto;
  width: 90%;
}

h1 {
  font-size: 1.5em;
  text-align: left;
}

.search {
  // display: flex;
  // position: relative;
  // align-items: center;
  // justify-content: flex-start;
  right: 0;
}

.input {
  max-width: 30%;
}

.footer {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 30px;
}

.tariff-table {
  width: 100%;
  max-width: 50%;

  &__row {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    color: #222;
    padding: 6px 0;

    span:last-child {
      text-align: right;
    }

    &--head {
      font-weight: 500;
      border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    }
  }
}

.blink {
  animation: blink-animation 1s steps(5, start) infinite;
  -webkit-animation: blink-animation 1s steps(5, start) infinite;
}
@keyframes blink-animation {
  to {
    visibility: hidden;
  }
}
@-webkit-keyframes blink-animation {
  to {
    visibility: hidden;
  }
}
</style>
